const SWATCHES_IMAGES = 
      {
// Image list for size swatches 
// Product Name : Standard Size
// URL : https://www.thefashioncorsetshop.com/products/standard-size
        '_g9y5mhhmx_images' :
        {
          0 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/FINAL1.jpg',
          1 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/FINAL1.jpg',
          2 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/FINAL1.jpg',
          3 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/FINAL1.jpg',
          4 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/FINAL1.jpg',
          5 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/FINAL1.jpg',
          6 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/FINAL1.jpg',
          7 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/FINAL1.jpg',
          8 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/FINAL1.jpg',
          9 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/FINAL1.jpg',
          10 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/FINAL1.jpg',
          11 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/FINAL1.jpg',
          12 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/FINAL1.jpg',
          13 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/FINAL1.jpg',
          14 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/FINAL1.jpg',
          15 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/FINAL1.jpg',
          16 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/FINAL1.jpg'
  
        },
        
// Button Image list for size swatches 
// Product Name : Standard Button Size
// URL : https://www.thefashioncorsetshop.com/products/standard-size
        '_g9y5mhhmx_buttons' :
        {
          0 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          1 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          2 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          3 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          4 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          5 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          6 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          7 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          8 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          9 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          10 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          11 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          12 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          13 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          14 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          15 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          16 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png'
  
        },
                
// Button Image list for size swatches 
// Product Name : Standard Button Size
// URL : https://www.thefashioncorsetshop.com/products/standard-size
        '_d8nglxw6w_images' :
        {
          0 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Baby_Pink_Suspender_Garter_belt_6_piece_720x@2x.jpg',
          1 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Ivory_Suspender_Garter_belt_6_piece_720x@2x.jpg',
          2 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Maroon_Suspender_Garter_belt_6_piece_720x@2x.jpg',
          3 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Purple_Suspender_Garter_belt_6_piece_720x@2x.jpg',
          4 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Red_Suspender_Garter_belt_6_piece_720x@2x.jpg',
          5 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Rust_Brown_Suspender_Garter_belt_6_Piece_720x@2x.jpg',
          6 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Turquoise_Suspender_Garter_belt_6_piece_720x@2x.jpg',
          7 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Baby_Pink_Suspender_Garter_belt_4_piece_720x@2x.jpg',
          8 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Ivory_Suspender_Garter_belt_4_piece_720x@2x.jpg',
          9 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Maroon_Suspender_Garter_belt_4_piece_720x@2x.jpg',
          10 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Purple_Suspender_Garter_belt_4_piece_720x@2x.jpg',
          11 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Red_Suspender_Garter_belt_4_piece_720x@2x.jpg',
          12 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Rust_Brown_Suspender_Garter_belt_4_Piece_720x@2x.jpg',
          13 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Turquoise_Suspender_Garter_belt_4_piece_720x@2x.jpg',
          14 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Baby_Pink_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          15 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Ivory_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          16 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Maroon_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          17 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Purple_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          18 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Red_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          19 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Rust_Brown_Suspender_Garter_belt_1_Piece_720x@2x.jpg',
          20 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Turquoise_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          21 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          22 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png'
  
        },
                
// Button Image list for size swatches 
// Product Name : Standard Button Size
// URL : https://www.thefashioncorsetshop.com/products/standard-size
        '_z6syne6ow_images' :
        {
          0 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Baby_Pink_Suspender_Garter_belt_6_piece_720x@2x.jpg',
          1 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Ivory_Suspender_Garter_belt_6_piece_720x@2x.jpg',
          2 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Maroon_Suspender_Garter_belt_6_piece_720x@2x.jpg',
          3 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Purple_Suspender_Garter_belt_6_piece_720x@2x.jpg',
          4 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Red_Suspender_Garter_belt_6_piece_720x@2x.jpg',
          5 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Rust_Brown_Suspender_Garter_belt_6_Piece_720x@2x.jpg',
          6 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Turquoise_Suspender_Garter_belt_6_piece_720x@2x.jpg',
          7 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Baby_Pink_Suspender_Garter_belt_4_piece_720x@2x.jpg',
          8 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Ivory_Suspender_Garter_belt_4_piece_720x@2x.jpg',
          9 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Maroon_Suspender_Garter_belt_4_piece_720x@2x.jpg',
          10 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Purple_Suspender_Garter_belt_4_piece_720x@2x.jpg',
          11 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Red_Suspender_Garter_belt_4_piece_720x@2x.jpg',
          12 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Rust_Brown_Suspender_Garter_belt_4_Piece_720x@2x.jpg',
          13 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Turquoise_Suspender_Garter_belt_4_piece_720x@2x.jpg',
          14 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Baby_Pink_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          15 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Ivory_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          16 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Maroon_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          17 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Purple_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          18 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Red_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          19 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Rust_Brown_Suspender_Garter_belt_1_Piece_720x@2x.jpg',
          20 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Turquoise_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          21 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          22 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png'
  
        },
                
// Button Image list for size swatches 
// Product Name : Standard Button Size
// URL : https://www.thefashioncorsetshop.com/products/standard-size
        '_m8l3utd3e_images' :
        {
          0 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/files/sturdy_heavy_silver_busk_Clip_Corsets_queen_png.png?v=1792740469',
          1 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/files/antique_busk_1_85f3b528-2aec-4d4c-9229-02f3b4c6d5ca.png?v=1792658750',
          2 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/files/silver_clasp_1_060dfaa7-5b17-458f-81cd-6ba8cd4b22a0.png?v=1789502520',
          3 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/files/antique_clasp_1_9c492527-0fcf-439f-aa03-81ee991943b0.png?v=1789502520',
          4 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/files/Silver_Zipper_1_f50d29ba-92aa-4092-b7e6-581016c34c3f.png?v=1789502520',
          5 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/files/antique_zipper_1_f11e32c2-7dfb-4efe-b372-999388194d05.png?v=1789502520',
          6 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/files/White_Lacing_Cord_5.png?v=1792668682',
          7 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/files/Black_Lacing_Cord_5.png?v=1792668683',
          8 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/files/Brown_Lacing_Cord.png?v=1792668682',
          9 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/files/Front_closed_zipper_b81afc6d-9845-4ec6-9231-2c0fb2fc6a78.png?v=1792669742',
          10 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/files/Front_Closed_No_Side_Zipper.png?v=1789506783',
          11 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Red_Suspender_Garter_belt_4_piece_720x@2x.jpg',
          12 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Rust_Brown_Suspender_Garter_belt_4_Piece_720x@2x.jpg',
          13 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Turquoise_Suspender_Garter_belt_4_piece_720x@2x.jpg',
          14 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Baby_Pink_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          15 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Ivory_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          16 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Maroon_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          17 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Purple_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          18 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Red_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          19 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Rust_Brown_Suspender_Garter_belt_1_Piece_720x@2x.jpg',
          20 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Turquoise_Suspender_Garter_belt_1_piece_720x@2x.jpg',
          21 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png',
          22 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/Line-art.png'
  
        },
        

// Button Image list for size swatches 
// Product Name : Standard Button Size
// URL : https://www.thefashioncorsetshop.com/products/standard-size
        '_bokf42z90_images' :
        {
          0 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_1.jpg',
          1 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_2.jpg',
          2 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_3.jpg',
          3 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_4.jpg',
          4 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_5.jpg',
          5 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_6.jpg',
          6 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_7.jpg',
        },
        
// Button Image list for size swatches 
// Product Name : Standard Button Size
// URL : https://www.thefashioncorsetshop.com/products/standard-size
        '_i9vrffw2x_images' :
        {
          0 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_1.jpg',
          1 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_2.jpg',
          2 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_3.jpg',
          3 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_4.jpg',
          4 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_5.jpg',
          5 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_6.jpg',
          6 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_7.jpg',
        },
        
// Button Image list for size swatches 
// Product Name : Standard Button Size
// URL : https://www.thefashioncorsetshop.com/products/standard-size
        '_tkz916ifi_images' :
        {
          0 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_1.jpg',
          1 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_2.jpg',
          2 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_3.jpg',
          3 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_4.jpg',
          4 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_5.jpg',
          5 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_6.jpg',
          6 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_7.jpg',
        },
        
// Button Image list for size swatches 
// Product Name : Standard Button Size
// URL : https://www.thefashioncorsetshop.com/products/standard-size
        '_zfmkhivjv_images' :
        {
          0 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_1.jpg',
          1 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_2.jpg',
          2 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_3.jpg',
          3 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_4.jpg',
          4 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_5.jpg',
          5 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_6.jpg',
          6 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_7.jpg',
        },
   
        
        
        
        
// Button Image list for size swatches 
// Product Name : Standard Button Size
// URL : https://www.thefashioncorsetshop.com/products/standard-size
        '_6n9o61bvx_images' :
        {
          0 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/HeavyDutyblackLace.jpg',
          1 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/HeavyDutyWhiteLace.jpg',
          2 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/HeavyDutyBlackSatinTape.jpg',
          3 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/HeavyDutyWhiteSatinTape.jpg',
          4 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/files/RedSatin.png?v=1755863449',
          5 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/files/MaroonSatin.png?v=1755863448',
          6 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/files/TurquoiseSatin.png?v=1755863449',
          7 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/files/LavanderSatin.png?v=1755863449',
          8 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/files/BabyPinkSatin.png?v=1755863449',
          9 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_7.jpg',
          10 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_7.jpg',
          11 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_7.jpg',
          12 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_7.jpg',
          13 : 'https://cdn.shopify.com/s/files/1/0027/2180/8482/products/fabric_7.jpg',
        },	


        
};


// THIS IS FOR THE MODAL DYNAMIC TITLE BASED ON UNIQUE ID

const SWATCHES_MODAL_HEADING = 
      {
// Heading list for the modal 
        '_bokf42z90' :
        {
          0 : 'Below are for the Customize given details' 
        },
        '_2gk9ei954' :
        {
          0 : 'Below are for the Standard given details' 
        },
        '_m8l3utd3e' :
        {
          0 : 'Below are for the Front Opening given details' 
        },
        '_2zlppussp' :
        {
          0 : 'Below are for the Front Opening given details' 
        },
        '_z6syne6ow' :
        {
          0 : 'Below are for the Garter / Suspender given details,' 
        }
        
       	
}; 